//In-Page Alerts
export const EMAIL_CONFIRM = "EMAIL_CONFIRM";

export const MAKE_GROUP_PUBLIC = "MAKE_GROUP_PUBLIC"

export const MAKE_USER_VISIBLE = "MAKE_USER_VISIBLE"

export const FETCH_SINGLE_GROUP_FAILED = "FETCH_SINGLE_GROUP_FAILED";

export const FETCH_USER_PROFILE_FAILED = "FETCH_USER_PROFILE_FAILED";

export const INVITATION_LINK_PROBLEM = "INVITATION_LINK_PROBLEM";

export const INVITATION_LINK_ALREADY_IN_GROUP = "INVITATION_LINK_ALREADY_IN_GROUP";

export const DELETE_GROUP = "DELETE_GROUP";


//Snackbar

export const STANDARD_SIGN_UP_SUCCESS = "STANDARD_SIGN_UP_SUCCESS";
export const STANDARD_SIGN_UP_FAILED = "STANDARD_SIGN_UP_FAILED";

export const COPY_LINK_SUCCESS = "COPY_LINK_SUCCESS";
export const SENT_INVITATION_LINK_SUCCESS = "SENT_INVITATION_LINK_SUCCESS";
export const SENT_INVITATION_LINK_FAILED = "SENT_INVITATION_LINK_FAILED";

export const COPY_NEWS_LINK = "COPY_NEWS_LINK";

export const TOGGLE_TASK_FAILED = "TOGGLE_TASK_FAILED";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS"; 

export const SEND_RESET_PASSWORD_SUCCESS = "SEND_RESET_PASSWORD_SUCCESS";
export const SEND_RESET_PASSWORD_FAILED = "SEND_RESET_PASSWORD_FAILED";

export const LEAVE_GROUP_SUCCESS = "LEAVE_GROUP_SUCCESS";